import { connect } from 'react-redux';
import { submit } from 'redux-form';
import { withRouter } from 'react-router';

import { getTeamMembers, removeTeamMember, resendInvitation } from '../store/actions/teamMembers';
import TeamMembersComponent from '../components/profile/TeamMembers/TeamMembersComponent';
import { isUserAdmin } from './selectors/userSelectors';

const TEAM_MEMBER_FORM = 'team-member';

const mapStateToProps = (state, { history }) => ({
    members: state.teamMembers.items,
    isLoading: state.teamMembers.isLoading,
    currentCompanyId: state.companies.currentCompany.firebaseId,
    history,
    user: state.session.user,
    isUserAdmin: isUserAdmin(state),
});

const mapDispatchToProps = {
    getTeamMembers,
    removeTeamMember,
    resendInvitation,
    submitMemberForm: () => submit(TEAM_MEMBER_FORM),
};

const mergeProps = (
    { currentCompanyId, ...stateProps },
    { getTeamMembers, removeTeamMember, submitMemberForm, resendInvitation },
) => ({
    ...stateProps,
    currentCompanyId,
    submitMemberForm,
    getMembers: () => getTeamMembers(currentCompanyId),
    removeMember: removeTeamMember,
    resendInvitation: resendInvitation,
});

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(withRouter(TeamMembersComponent));



// WEBPACK FOOTER //
// ./src/containers/TeamMembersContainer.js